import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import Fab from '@material-ui/core/Fab';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
import Card from '../../components/Card';
import CardList from '../../components/CardList';
import Article from '../../components/Article';

import { TYPE_GRID, TYPE_DETAIL } from '../App/actions';
import { selectListType } from '../App/selectors';
import { requestWpPosts as requestWpPostsAction } from './actions';
import {
  selectWpLoading, selectWpErrorMessage, selectWpPostCurrentPage,
  selectWpPostHasMore, selectWpPostListEntities,
} from './selectors';
import CardListSkeleton from '../../components/CardList/skeleton';
import DynamicAd from '../../components/dynamic-ad';

export class WpPostList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showBackToTop: false,
      // currentPage: 0,
    };
  }

  componentDidMount() {
    this.requestPosts();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.name !== prevProps.name) {
      this.requestPosts();
    }
  }

  // TODO Use windowing instead
  requestPosts = () => {
    if (!this.props.loading) {
      this.props.requestWpPosts(this.props.currentPage + 1);
    }
  };

  renderRow(listType) {
    if (listType === TYPE_GRID) {
      return Card;
    }

    if (listType === TYPE_DETAIL) {
      return Article;
    }

    return CardList;
  }

  render() {
    const {
      hasMore,
      posts,
      listType,
    } = this.props;

    // FIXME Set this in a settings page (reading settings), default should be this TYPE_LIST tho
    const Item = this.renderRow(listType);

    return (
      <div>
        <InfiniteScroll
          dataLength={posts.toArray().length}
          next={this.requestPosts}
          hasMore={hasMore}
          loader={<CardListSkeleton />}
          onScroll={() => {
            // console.log(document.documentElement.scrollTop);
            this.setState({ showBackToTop: document.documentElement.scrollTop > 350 });
          }}
        >
          {this.props.name === 'all' && (
            <div className="feed-card-item">
              <DynamicAd zoneId="103065" />
            </div>
          )}
          {/* FIXME This isn't showing both the loader and the no articles found text - just add an article to Cigars 101? */}
          {/* {posts.toArray().length === 0 && <div style={{ textAlign: 'center', marginTop: 10 }}>No articles found</div>} */}
          {posts.toArray().map((post) => (
            <Item
              key={post.id}
              item={post}
            />
          ))}
        </InfiniteScroll>
        <Zoom
          in={this.state.showBackToTop}
          unmountOnExit
        >
          <Fab
            color="primary"
            aria-label="add"
            className="dark"
            style={{ position: 'fixed', bottom: 20, right: 20 }}
            onClick={() => {
              // Scroll back to the top
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <UpIcon color="secondary" />
          </Fab>
        </Zoom>
      </div>
    );
  }
}

WpPostList.propTypes = {
  requestWpPosts: PropTypes.func.isRequired,
  options: PropTypes.object,
  hasMore: PropTypes.bool,
  posts: PropTypes.object,
  listType: PropTypes.string,
};

const mapStateToProps = (state, props) => ({
  loading: selectWpLoading(props.name)(state),
  errorMessage: selectWpErrorMessage(props.name)(state),
  currentPage: selectWpPostCurrentPage(props.name)(state),
  hasMore: selectWpPostHasMore(props.name)(state),
  posts: selectWpPostListEntities(props.name)(state),
  listType: selectListType()(state),
});

function mapDispatchToProps(dispatch, props) {
  return {
    requestWpPosts: (page) => dispatch(requestWpPostsAction(props.name, page, props.options)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WpPostList);
